import { GenericTableFields, GenericTableField } from './generic-table-field';

export class PraticheTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("ID", "id_prat", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Emissione", "emissione", "label", "tab-cell-14 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Stato", "stato", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nominativo", "nominativo", "label", "tab-cell-27 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Data Notifica", "notifica_data", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Data Scadenza", "notifica_scadenza", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Totale Pratica", "totale_dovuto", "label", "tab-cell-10 text-right");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Pagato", "totale_pagato", "label", "tab-cell-10 text-right");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Residuo", "totale_residuo", "label", "tab-cell-10 text-right");
		this.header.push(headerField);
	}
}
